import { Modal } from "reactstrap";
import React from "react";
import {
  Button,
  Col as ColAnt,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
} from "antd";
import { connect } from "react-redux";
import { addFee } from "../../../store/financialSettings/actions";
import {
  currencyOptions,
  feeTypeOptions,
} from "../../../helpers/financial_settings_helper";

export const initialFormValues = {
  feeAmount: 0,
  currency: "BGN",
  feeType: "AMOUNT",
};

const AddFee = ({ open, onCancel, isLoading, addFee }) => {
  const [form] = Form.useForm();
  const onFinish = async (formData) => {
    try {
      const fee = {
        serviceCode: formData.serviceCode,
        feeType: formData.feeType,
        currency: formData.currency,
        feeAmount: formData.feeAmount,
        validFrom: formData.validFrom ? formData.validFrom.toDate() : null,
        validTo: formData.validTo ? formData.validTo.toDate() : null,
      };
      addFee(fee);
    } catch (err) {
      console.log(err?.response);
    }
  };
  const onFinishFailed = async (formData) => {
    console.log("on finish failed", formData);
  };

  return (
    <Modal isOpen={open} toggle={onCancel}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Добавяне на такса за транзакция</h5>
        <button
          type="button"
          onClick={() => {
            return onCancel();
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form
          form={form}
          className="editing-form editing-form-steps"
          layout="vertical"
          name="transactionFee"
          autoComplete="on"
          initialValues={initialFormValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <ColAnt xs={24}>
            <Form.Item
              name="serviceCode"
              label="Код на таксата"
              rules={[
                {
                  required: true,
                  message: "Моля, въведете код на таксата",
                  type: "string",
                  min: 3,
                  max: 50,
                },
              ]}
            >
              <Input placeholder="Код на таксата" maxLength={50} size="middle" />
            </Form.Item>
            <Form.Item
              name="feeType"
              label="Вид такса"
              rules={[
                {
                  required: true,
                  message: "Моля, изберете вид такса",
                },
              ]}
            >
              <Radio.Group options={feeTypeOptions} optionType="button" />
            </Form.Item>
            <Form.Item
              name="feeAmount"
              label="Стойност на таксата"
              rules={[
                {
                  required: true,
                  message: "Таксата за транзакция трябва да е по-голяма от 0",
                  type: "number",
                  min: 0.1,
                },
              ]}
            >
              <InputNumber
                placeholder="Стойност на таксата"
                changeOnWheel
                min={0}
                size="middle"
                type="number"
              />
            </Form.Item>
            <Form.Item name="currency" label="Валута">
              <Select
                value="BGN"
                aria-readonly="true"
                options={currencyOptions}
                disabled
              ></Select>
            </Form.Item>
            <Form.Item
              name="validFrom"
              label={"Валидна от"}
              className="input-box"
              rules={[
                {
                  type: "date",
                },
              ]}
            >
              <DatePicker className="input" format={"DD.MM.YYYY"} />
            </Form.Item>
            <Form.Item
              name="validTo"
              label={"Валидна до"}
              className="input-box"
              rules={[
                {
                  type: "date",
                },
              ]}
            >
              <DatePicker className="input" format={"DD.MM.YYYY"} />
            </Form.Item>
          </ColAnt>
          <Form.Item>
            <Button htmlType="submit" className="" disabled={isLoading}>
              Запази
            </Button>
          </Form.Item>
        </Form>
      </div>

      {isLoading && (
        <div className="modal-footer">
          <div className="spinner-border text-success m-1" role="status">
            <span className="sr-only">Зареждане...</span>
          </div>
        </div>
      )}
    </Modal>
  );
};
const mapStateToProps = ({ FinancialSettings }) => {
  return FinancialSettings;
};
export default connect(mapStateToProps, {
  addFee,
})(AddFee);
